import { render, staticRenderFns } from "./TabReplication.vue?vue&type=template&id=2d2c79be&scoped=true&"
import script from "./TabReplication.vue?vue&type=script&lang=js&"
export * from "./TabReplication.vue?vue&type=script&lang=js&"
import style0 from "./TabReplication.vue?vue&type=style&index=0&id=2d2c79be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c79be",
  null
  
)

export default component.exports